<template>
  <ImageHeader :headerTitle="$t('views.about.imageTitle')" :imageSource="require('../assets/leeb-images3/pic1.jpg')">
    <v-card elevation="0">
      <v-card-text>
        <p class="pb-2">{{ $t("views.about.thisWebApp") }}</p>
        <p class="pb-2">
          <b>LEEB Balkone GmbH</b><br>
          Maitratten 25<br>
          9563 Gnesau<br>
          Österreich<br>
        </p>
        <p class="pb-2">{{ $t("views.about.responsible") }}</p>
        <p class="pb-2">
          <b>Joel Strasser</b><br>
          {{ $t("views.about.department") }} IT<br>
          +43 4278 700 108<br>
          j.strasser@leeb-balkone.com<br>
        </p>
        <p class="pb-2">{{ $t("views.about.supportedBy") }}</p>
        <p class="pb-2">
          <ul>
            <li>Vue.js</li>
            <li>Vuetify</li>
            <li>Material Design</li>
            <li>Material Design Icons</li>
            <li>Axios</li>
          </ul>
        </p>
        <p class="pb-2">{{ $t("views.about.webAppVersion") }}</p>
        <p class="pb-2">
          <b>{{ version }}</b> ({{ gitHash }})
        </p>
      </v-card-text>
    </v-card>
  </ImageHeader>
</template>

<script>
import ImageHeader from '../components/ImageHeader.vue'

export default {
  name: 'About',
  components: {
    ImageHeader
  },
  data() {
    return {
      version: process.env.VUE_APP_CSPRTL_VERSION,
      gitHash: process.env.VUE_APP_CSPRTL_GITDESC
    }
  }
}
</script>
